import React from 'react';
import { I18n, Trans } from 'react-i18next';

import {Unesolution} from './Unesolution/Unesolution';



export class Introduction extends React.Component {
  
  

  render() {
   
    return (
      <I18n ns="translations">
        {
          (t, { i18n }) => (
                <div>
                  <div className="container">
                    <section id="top-section">
                      <div className="row">
                        <div className="col-md-8 col-md-push-4 col-sm-8 col-xs-12">
                          <div className="serve-sec">
                            <h4 className="head-text"><b>{t('servertitle')}</b></h4>
                            <p className="head-para">{t('serverpara1')}{t('serverpara2')}<i>{t('serveritalic')}</i>{t('serverpara3')}</p>
                          </div>
                          <div className="serve-sec">
                            
                            <h4 className="head-text"><b>{t('servertitle2')}</b></h4>
                            <p className="head-para">{t('serverpart1')}</p>
                            <p className="head-para">{t('serverpart2')}{t('serverpart3')}<i>{t('serveritalic2')}</i> {t('serverpart4')}</p>
                          </div>
                        </div>
                        <div className="col-md-4 col-md-pull-8 col-sm-4 col-xs-12 tr res-center">
                          <img className="server-img" src="../../images/server.png"/>
                        </div>
                        
                      </div>
                    </section>
                    </div>
                   <Unesolution/>
                </div>
             )
          }
      </I18n>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Introduction/Introduction.js